import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Mail, Lock, Eye, EyeOff } from "lucide-react";
import { useLogin } from "../../Hooks/useLogin";
import WaveAnimatio from "../animation/WaveAnimatio";

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const loginMutation = useLogin();

    useEffect(() => {
        if (loginMutation.isSuccess) {
            const userData = localStorage.getItem("user_data");
            if (userData) {
                const timer = setTimeout(() => {
                    window.location.href = "/profile";
                }, 1000);

                return () => clearTimeout(timer);
            }
        }
    }, [loginMutation.isSuccess]);

    useEffect(() => {
        if (loginMutation.isError) {
        }
    }, [loginMutation.isError]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email || !password) {
            return;
        }

        loginMutation.mutate({ email, password });
    };

    return (
        <section className="min-h-screen flex items-center justify-center relative overflow-hidden bg-gradient-to-br from-gray-50 via-blue-50 to-purple-50">
            <WaveAnimatio />

            <div className="relative z-10 w-full max-w-sm">
                <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
                    <div className="bg-white px-8 py-6 text-center">
                        <div className="w-[100px] h-[100px] mx-auto mb-3 flex items-center justify-center">
                            <img
                                src={require("../../assets/logo/logo.svg").default}
                                alt="Logo"
                                className="w-full h-full object-contain"
                            />
                        </div>
                        <h1 className="text-2xl font-bold animated-text">Company Portal</h1>
                        <p className="text-gray-600 mt-2">Welcome back! Login to your account now!</p>
                    </div>

                    <div className="p-8 space-y-6">
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div className="relative">
                                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    placeholder="Email"
                                    className="w-full pl-12 pr-4 py-4 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#1665f6] transition text-gray-800"
                                />
                            </div>

                            <div className="relative">
                                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                                <input
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    placeholder="Password"
                                    className="w-full pl-12 pr-14 py-4 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#1665f6] transition text-gray-800"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition"
                                >
                                    {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                                </button>
                            </div>

                            <button
                                type="submit"
                                disabled={loginMutation.isPending}
                                className="w-full py-4 bg-gradient-to-r from-[#1665f6] to-[#8830b8] text-white font-bold rounded-xl shadow-lg hover:shadow-xl transition disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                            >
                                {loginMutation.isPending ? (
                                    <>
                                        <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                        </svg>
                                        Signing in...
                                    </>
                                ) : (
                                    "Sign In"
                                )}
                            </button>
                        </form>

                        <p className="text-center text-xs text-gray-500">
                            By signing in, you agree to our{" "}
                            <Link to="/terms" className="text-[#8830b8] font-medium hover:underline">
                                Terms
                            </Link>{" "}
                            &{" "}
                            <Link to="/privacy" className="text-[#8830b8] font-medium hover:underline">
                                Privacy
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}